module.exports = __webpack_public_path__ + "img/admin-menu-item.ea1c0fca.webp";